import { render } from "./HistoryShipment.vue?vue&type=template&id=5d7710ea"
import script from "./HistoryShipment.vue?vue&type=script&lang=js"
export * from "./HistoryShipment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__